import './index.scss';

import React from 'react';

import MustTryTag from '../../../assets/images/tags.png';

const ImageTag = () =>{
  return(
    <div className="imagetag">
      <img
        src={MustTryTag}
        alt="Must try"
        className="imagetag-img"
      />
      <div className="imagetag-name">MUST TRY</div>
    </div>
  )
}

export default ImageTag;